module.exports = __webpack_public_path__ + "static/DHCM5-b342e5b5e5e523b62aa10975cab96bdd.png";